var map = {
	"./007-microphone-1.png": 652,
	"./010-home.png": 653,
	"./013-document-1.png": 654,
	"./014-document.png": 655,
	"./015-color-palette.png": 656,
	"./017-video-camera.png": 657,
	"./024-like.svg": 628,
	"./1.svg": 658,
	"./155-credit-card.svg": 629,
	"./2.svg": 659,
	"./3.svg": 660,
	"./4.svg": 661,
	"./New Customer.svg": 662,
	"./NotOpen.svg": 663,
	"./Opened.svg": 664,
	"./Profit.svg": 665,
	"./SalesRevenue.svg": 666,
	"./Sent.svg": 667,
	"./Slack.svg": 668,
	"./address.svg": 630,
	"./adobe.svg": 669,
	"./arrow-left.svg": 285,
	"./arrow-right.svg": 286,
	"./book.svg": 670,
	"./camera.svg": 671,
	"./chat.svg": 672,
	"./clipboard.svg": 673,
	"./cloud.svg": 674,
	"./columns.svg": 675,
	"./documentation.svg": 676,
	"./file.svg": 677,
	"./flat.svg": 678,
	"./headphone.svg": 679,
	"./iconfinder_trello_2317760.svg": 680,
	"./idea.svg": 681,
	"./image.png": 682,
	"./image.svg": 683,
	"./label.png": 684,
	"./layers.svg": 685,
	"./left.svg": 686,
	"./logo2.svg": 687,
	"./logo3.svg": 688,
	"./logo4.svg": 689,
	"./logo5.svg": 690,
	"./logo6.svg": 691,
	"./logoIn.svg": 692,
	"./paint.svg": 693,
	"./protection.svg": 694,
	"./quote.png": 695,
	"./repeat.svg": 696,
	"./right.svg": 697,
	"./strategy.svg": 698,
	"./theme.svg": 699,
	"./tiktok.svg": 424,
	"./user.svg": 631,
	"./water-fall.svg": 700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 651;